
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  informationHeaderText: {
    marginBottom: '0 !important',
  },
  informationBodyText: {
    color: '#686868',
    padding: '10px 0px 40px',
    fontSize: '16px',
  },
  contentContainer: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '1px 27px 27px !important',
    position: 'relative',
    margin: 'auto',
    maxWidth: '460px',
    [theme.breakpoints.only('xs')]: {
      minHeight: '683px',
      width: '100% !important',
      borderRadius: 0,
      margin: 'inheit',
      top: 0,
    }
  },
  outerContainer: {
    flex: '1 0 auto',
  },
  button: {
    color: '#ffffff',
    backgroundColor: '#e2000f',
    padding: '7px 16px',
    boxShadow: 'none',
    borderRadius: '4px',
    fontWeight: 600,
    fontSize: '16px',
    height: '42px',
    border: 0,
    fontFamily: 'myriad-pro',
    '&:hover': {
      backgroundColor: '#80000a',
      cursor: 'pointer',
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%'
    }
  },
  headerText: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#000',
  },
}));

